import { getParameterByName } from './getParameterByName';
import { isClient } from './device';

export const inIframe = isClient && !!(window.frameElement || window !== window.parent);

export const isEmbedded = isClient && !!(inIframe || (getParameterByName('token') || '').match(/_app$/));
